import {
    Link,
    ProgressBar,
    Toast,
    ToastBody,
    ToastTitle,
    ToastTrigger,
    useId,
    useToastController,
} from "@fluentui/react-components";
import { useEffect } from "react";

type Props = {
    value: number;
    max: number;
    uploading: boolean;
    toasterId: string;
};

export const Progress = ({ value, max, uploading, toasterId }: Props) => {
    const toastId = useId("analyze");
    const { dispatchToast, updateToast } = useToastController(toasterId);

    useEffect(() => {
        if (uploading) {
            dispatchToast(jsxToastProgress(value, max), {
                toastId,
                timeout: -1,
                intent: "info",
            });
        }
    }, [uploading]);

    useEffect(() => {
        updateToast(
            value === max
                ? {
                      toastId,
                      content: jsxToastSuccess(max),
                      intent: "success",
                  }
                : {
                      toastId,
                      content: jsxToastProgress(value, max),
                      intent: "info",
                  }
        );
    }, [value, max]);

    const jsxToastProgress = (value: number, max: number) => {
        return (
            <Toast>
                <ToastTitle>
                    Starting Analyses ({value}/{max})
                </ToastTitle>
                <ToastBody>
                    <ProgressBar value={value} max={max} />
                </ToastBody>
            </Toast>
        );
    };

    const jsxToastSuccess = (max: number) => {
        return (
            <Toast>
                <ToastTitle
                    action={
                        <ToastTrigger>
                            <Link>Dismiss</Link>
                        </ToastTrigger>
                    }
                >
                    Started {max} {max === 1 ? "analysis" : "analyses"}
                </ToastTitle>
            </Toast>
        );
    };

    return <></>;
};
